
import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';
import { DEFAULT_SENSITIVITY_CONFIG_FOR_METRIC, DEFAULT_SENSITIVITY_CONFIG_FOR_APP_METRIC } from '@utils/aiAlerts/mapping';
import { APP_AI_ALERT_METRIC_LIST } from '@utils/aiAlerts/metrics';

const selector = state => get(state, SCOPE);

export const loadingSelector = createSelector(
  selector,
  store => store.isFetching,
);

export const sensitivityDataSelector = createSelector(
  selector,
  store => store.sensitivityMetricConfigList,
);

export const selectedSensitivityMetricSelector = createSelector(
  selector,
  store => store.selectedMetric,
);

export const sensitivityLogsLoadingSelector = createSelector(
  selector,
  store => store.isLogsFetching,
);

export const sensitivityLogsSelector = createSelector(
  selector,
  store => store.sensitivityLogs,
);

export const currentConfigSelector = createSelector(
  selector,
  store => store.currentConfig
)

export const currentConfigErrorSelector = createSelector(
  selector,
  store => store.currentConfigErrorMsg
)

export const selectedConfigSelector = createSelector(
  selectedSensitivityMetricSelector,
  sensitivityDataSelector,
  (selectedMetric, sensitivityList) => {
    let selectedConfig = sensitivityList.find(item => item.metric === selectedMetric);
    const defaultConfig = window.conviva.module === 'APP'
      ? DEFAULT_SENSITIVITY_CONFIG_FOR_APP_METRIC
      : DEFAULT_SENSITIVITY_CONFIG_FOR_METRIC;
    if (!selectedConfig) {
      selectedConfig = {
        ...defaultConfig,
        metric: selectedMetric,
        asf: 1,
        app: selectedMetric.startsWith('AD_')
          ? 'ai'
          : (APP_AI_ALERT_METRIC_LIST.includes(selectedMetric) ? 'ae' : 'ei'),
      };
    }
    return selectedConfig;
  }
)

export default selector;
